export const BOX_KEYS = {
  under: 'under',
  bottom: 'bottom',
  medium: 'medium',
  high: 'high',
  top: 'top',
} as const

export const BOXES: Array<{ key: string; label: string; color: string }> = [
  {
    key: BOX_KEYS.under,
    label: 'placeme.tile.snv_potential_model.under',
    color: '#D1D1D1',
  },
  {
    key: BOX_KEYS.bottom,
    label: 'placeme.tile.snv_potential_model.bottom',
    color: '#A62E43',
  },
  {
    key: BOX_KEYS.medium,
    label: 'placeme.tile.snv_potential_model.medium',
    color: '#DECA79',
  },
  {
    key: BOX_KEYS.high,
    label: 'placeme.tile.snv_potential_model.high',
    color: '#99B8E0',
  },
  {
    key: BOX_KEYS.top,
    label: 'placeme.tile.snv_potential_model.top',
    color: '#75A460',
  },
]
